import React, { useContext } from 'react';
import Types, { isLiteral } from 'constants/types';
import Predicates from 'constants/predicates';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import BooleanEdit from './BooleanEdit';
import EnumEdit from './EnumEdit';
import LiteralEdit from './LiteralEdit';
import ResourceEdit from './ResourceEdit';
import AttachmentEdit from './resource/AttachmentEdit';
import ImageEdit from './resource/ImageEdit';
import TermEdit from './TermEdit';
import CategoryEdit from './CategoryEdit';

import FieldErrorBoundary from 'field/common/FieldErrorBoundary';
import FieldContext from 'field/FieldContext';
import { getField } from 'helpers/fieldHelpers';

/**
 * @param {*} props: field
 * @param field: (type, predicate, minOccurs, maxOccurs, info, label)
 * Maps field from JSON into corresponding React component.
 */
const Field = (props) => {
  const field = props.field;
  const FC = useContext(FieldContext);
  
  if (!field || !field.props || field.props.hidden) {
    return null;
  }

  const component = FC.getEditField(props);
  if (component != null) {
    return component;
  }

  if (field.predicate === Predicates.IMAGEARCHIVE.CATEGORY){
    return <CategoryEdit {...props} />;
  }

  // SPEC-36, 37, 38 images, attachments, references tabs
  switch (field.type) {
  case Types.ARCHIVE.IMAGE:
    return <ImageEdit {...props} />;
      
  case Types.ARCHIVE.DOCUMENT:
    return <AttachmentEdit {...props} />;
    
  case Types.XSD.BOOLEAN:
    return <BooleanEdit {...props} />;
  }
          
  if (field.props.enum) {
    return <EnumEdit {...props} />;
  }
  if (field.props.term) {
    return <TermEdit {...props} />;
  }
      
  if (isLiteral(field.type)) {
    return <LiteralEdit {...props} />;
  } else {
    return <ResourceEdit {...props} />;
  }
};

const FieldEdit = props => (
  <FieldErrorBoundary field={props.field} >
    <Field {...props} />
  </FieldErrorBoundary>
);

FieldEdit.propTypes = {
  field: PropTypes.object,
};

// Overrides field with stateful Redux field
const mapStateToProps = (state, props) => {
  return { field: getField(state, props.field) };
};

export default connect(mapStateToProps)(FieldEdit);